<template>
	<div>
		<div class="yaccount">
			<div>
				<div data-v-486d5814="" data-v-30babe2d="" class="my-header">
					<div data-v-486d5814=""
						class="header-row van-row van-row--flex van-row--align-center van-row--justify-space-between">
						<div data-v-486d5814="" class="van-col van-col--8">
							<div data-v-459e9abf="" class="van-dropdown-menu">
								<div class="van-dropdown-menu__bar" @click="lang_open()">
									<div role="button" tabindex="0" class="van-dropdown-menu__item"><span
											class="van-dropdown-menu__title" style="">
											<div class="van-ellipsis" id="lang_text">{{xz_lang}}</div>
										</span></div>
								</div>
								<div data-v-459e9abf="">
									<div class="van-dropdown-item van-dropdown-item--down" style="top: 48.9531px;;"
										id="lang_div" v-show="lang_div">
										<div class="van-overlay"
											style="z-index: 2003; position: absolute; animation-duration: 0.2s; display: ;"
											@click="lang_open()">
										</div>
										<div class="van-popup van-popup--top van-dropdown-item__content"
											style="transition-duration: 0.2s; z-index: 2004; display: ;">

											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option" style=""
												@click="change('en','English')">
												<div class="van-cell__title"><span>English</span></div>
											</div>

											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('tu','Türkçe')">
													<span>Türkçe</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('po','Português')">
													<span>Português</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('al','عربي')">
													<span>عربي</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('de','Deutsch')">
													<span>Deutsch</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('xi','español')">
													<span>español</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('yi','Italiano')">
													<span>Italiano</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('el','Русский')">
													<span>Русский</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('ja','日本')">
													<span>日本</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option"
												@click="change('zh','简体中文')">
												<div class="van-cell__title"><span>简体中文</span></div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option "
												@click="change('fa','繁体中文')">
												<div class="van-cell__title"><span>繁体中文</span></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div data-v-486d5814="" class="van-col van-col--8">
							<div data-v-486d5814="" class="flex align-center justify-center">
								<h2 data-v-486d5814="" class="plat-name">Pool</h2>
							</div>
						</div>
						<div data-v-486d5814="" class="van-col van-col--8"
							style="text-align: right; padding-right: 10px;">
							<button data-v-486d5814="" disabled="disabled"
								class="van-button van-button--default van-button--mini van-button--plain van-button--disabled van-button--hairline van-hairline--surround"
								style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%;">
								<div data-v-486d5814="" class="van-button__content"><img :src="bi_img"
										style="width: 20px;height: 20px;" /><span data-v-486d5814=""
										class="van-button__text"
										style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;font-size:10px;margin-left: 10px;">{{selectedAccount}}</span>
								</div>
							</button>
						</div>
					</div>
				</div> <!---->
			</div>
			<div data-v-30babe2d="" class="body-center ypage-box">
				<div data-v-30babe2d="" class="assets-top box-shadow">
					<div data-v-30babe2d="" style="display: flex;" @click="tz('/record')">
						<div data-v-30babe2d="" style="height: 50%;"><i data-v-30babe2d=""
								class="van-icon van-icon-balance-list-o" style="font-size: 16px;"></i> <span
								data-v-30babe2d="" class="fs14" data-lang="string_41">{{$t('记录')}}</span></div>
					</div>
				</div>
				<div data-v-30babe2d="" class="assets-top box-shadow">
					<div data-v-30babe2d="" class="tl flex align-center justify-between">
						<div data-v-30babe2d=""><span data-v-30babe2d="" class="desc"
								data-lang="string_84">{{$t('累计收益')}}</span>
							<h2 data-v-30babe2d="" class="number link-color"><span
									id="zong_shouyi">{{user_data.zong_shouyi}}{{type}}</span>
							</h2>
						</div>


						<button v-show="zhiya_kaiqi" data-v-30babe2d=""
							class="van-button van-button--primary van-button--small van-button--round"
							@click="sq_zhiya()">
							<div data-v-30babe2d="" class="van-button__content"><i data-v-30babe2d=""
									class="van-icon van-icon-cash-back-record van-button__icon"></i> <span
									data-v-30babe2d="" class="van-button__text" data-lang="string_57">{{$t('申请加入')}}
								</span></div>
						</button>

						<button v-show="zhiya_kaiqi_guanbi" data-v-30babe2d=""
							class="van-button van-button--primary van-button--small van-button--round"
							style="background-color:#C0C0C0;border:1px solid #C0C0C0;">
							<div data-v-30babe2d="" class="van-button__content"><i data-v-30babe2d=""
									class="van-icon van-icon-cash-back-record van-button__icon"></i> <span
									data-v-30babe2d="" class="van-button__text" data-lang="string_57">{{$t('申请加入')}}
								</span></div>
						</button>

						<button v-show="zhiya_guanbi" data-v-30babe2d=""
							class="van-button van-button--primary van-button--small van-button--round"
							style="background-color:#C0C0C0;border:1px solid #C0C0C0;">
							<div data-v-30babe2d="" class="van-button__content" id="guanbi_daojishi"><i
									data-v-30babe2d="" class="van-icon van-icon-cash-back-record van-button__icon"></i>
								<span data-v-30babe2d="" class="van-button__text" data-lang="string_39">{{$t('已质押')}}
								</span>
								<p id="day_num">{{user_data.day_num}}</p>
								<p data-lang="string_87">{{$t('天')}}</p>
							</div>

							<div data-v-30babe2d="" class="van-button__content" id="kaiqi_daojishi"><i
									data-v-30babe2d="" class="van-icon van-icon-cash-back-record van-button__icon"></i>
								<span data-v-30babe2d="" class="van-button__text" id="pTime">
								</span>
							</div>

						</button>



					</div>
					<div style="text-align:right;margin-top:-10px;padding-right:10px;font-size:12px;color:#C0C0C0;"
						data-lang="string_95">{{$t('高级矿池限时开放')}}</div>
					<br>
					<div data-v-30babe2d="" class="van-row--flex align-center justify-between">
						<div data-v-30babe2d="" class="tab-con-item flex-direction align-start" style="width: 50%;">
							<span data-v-30babe2d="" class="desc" data-lang="string_92">{{$t('昨日收益')}}</span>
							<div>
								<span data-v-30babe2d="" class="number link-color"
									id="last_sy_money">{{last_sy_money}}</span> <span data-v-30babe2d=""
									class="number link-color">{{type}}</span>
							</div>
						</div>

						<div data-v-30babe2d="" class="tab-con-item flex-direction align-center" style="width: 50%;">
							<span data-v-30babe2d="" class="desc" data-lang="string_83">{{$t('今日预收益')}}</span>
							<div>
								<span data-v-30babe2d="" class="number link-color"
									id="today_ysy">{{today_ysy}}</span>&nbsp;<span data-v-30babe2d=""
									class="number link-color">{{type}}</span>
							</div>
						</div>


						<div data-v-30babe2d="" class="tab-con-item flex-direction align-center"
							v-show="putong_kuangchi" style="width: 50%;margin-top: 10px;">
							<span data-v-30babe2d="" class="desc" data-lang="string_52">{{$t('普通矿池')}}</span>
							<div>
								<span data-v-30babe2d="" class="number link-color"
									id="balance_my">{{zong_balance}}</span>&nbsp;<span data-v-30babe2d=""
									class="number link-color">USDT</span>
							</div>
						</div>

						<div data-v-30babe2d="" class="tab-con-item flex-direction align-center" v-show="gaoji_kuangchi"
							style="width: 50%;margin-top: 10px;">
							<span data-v-30babe2d="" class="desc" data-lang="string_53">{{$t('高级矿池')}}</span>
							<div>
								<span data-v-30babe2d="" class="number link-color"
									id="wd_zhiya_money">{{wd_zhiya_money}}</span>&nbsp;<span data-v-30babe2d=""
									class="number link-color">USDT</span>
							</div>
						</div>

						<div data-v-30babe2d="" class="tab-con-item flex-direction align-center"
							style="width: 50%;margin-top: 10px;"><span data-v-30babe2d="" class="desc"
								data-lang="string_90">{{$t('下次收益')}}</span>
							<div>
								<span data-v-30babe2d="" class="number link-color" id="djs">
									{{hour}}:{{min}}:{{second}}</span>
							</div>
						</div>
					</div>
				</div>
				<div data-v-30babe2d="" class="assets-bottom">
					<div data-v-30babe2d="" class="list-account box-shadow">
						<div data-v-30babe2d="" class="ac-top flex align-center justify-between">
							<div data-v-30babe2d="" class="flex align-center justify-between"><img data-v-30babe2d=""
									:src="bi_img" width="30">
								<span data-v-30babe2d="" class="m-l-10">{{type}}</span>
							</div> <button data-v-30babe2d=""
								class="van-button van-button--primary van-button--small van-button--round"
								@click="tz('/exchange')">
								<div data-v-30babe2d="" class="van-button__content"><i data-v-30babe2d=""
										class="van-icon van-icon-exchange van-button__icon"></i> <span
										data-v-30babe2d="" class="van-button__text" data-lang="string_42">{{$t('兑换')}}
									</span></div>
							</button>
						</div>
						<div data-v-30babe2d="" class="ac-body flex align-center justify-between">
							<div data-v-30babe2d="" class="flex flex-sub flex-direction align-start">
								<h4 data-v-30babe2d="" data-lang="string_54">{{$t('全部的')}}</h4>
								<p data-v-30babe2d="" class="fs14" id="dtx_my">
									{{Math.floor(user_data.all_dtx * 1000000) / 1000000}}{{type}}
								</p>
							</div>
							<div data-v-30babe2d="" class="flex flex-sub flex-direction align-center">
								<h4 data-v-30babe2d="" data-lang="string_91">{{$t('当前收益率')}}</h4>
								<p data-v-30babe2d="" class="fs14">{{dqsyl}}</p>
							</div>


							<div data-v-30babe2d="" class="flex flex-sub flex-direction align-end">
								<h4 data-v-30babe2d="" data-lang="string_56">{{$t('可用的')}}</h4>
								<p data-v-30babe2d="" class="fs14" id="dtx_my_2">
									{{Math.floor(user_data.dtx * 1000000) / 1000000}}
									{{type}}
								</p>
							</div>
						</div>
					</div>







					<div data-v-30babe2d="" class="list-account box-shadow">
						<div data-v-30babe2d="" class="ac-top flex align-center justify-between">
							<div data-v-30babe2d="" class="flex align-center justify-between"><img data-v-30babe2d=""
									src="../../public/img/ustd-logo_78234c021a516747047a450cda026e00.png" width="30">
								<span data-v-30babe2d="" class="m-l-10">USDT</span>
							</div>


							<button data-v-30babe2d=""
								class="van-button van-button--primary van-button--small van-button--round"
								@click="tz('/exchange?type=2')">
								<div data-v-30babe2d="" class="van-button__content"><i data-v-30babe2d=""
										class="van-icon van-icon-cash-back-record van-button__icon"></i> <span
										data-v-30babe2d="" class="van-button__text">{{$t('提取')}}
									</span></div>
							</button>
						</div>
						<div data-v-30babe2d="" class="ac-body flex align-center justify-between">
							<div data-v-30babe2d="" class="flex flex-sub flex-direction align-start" id="pt_in_money">
								<h4 data-v-30babe2d="" data-lang="string_54">{{$t('全部的')}}</h4>
								<p data-v-30babe2d="" class="fs14" id="all_balance_my">{{all_u_balance}}USDT</p>
							</div>

							<div data-v-30babe2d="" class="flex flex-sub flex-direction align-start" id="gj_in_money"
								style="display:none;">
								<h4 data-v-30babe2d="" data-lang="string_54">{{$t('全部的')}}</h4>
								<p data-v-30babe2d="" class="fs14" id="all_zhiya_balance_my">0.00</p>
							</div>
							<!--<div data-v-30babe2d="" class="flex flex-sub flex-direction align-center">-->
							<!--	<h4 data-v-30babe2d="" data-lang="string_53"></h4>-->
							<!--	<p data-v-30babe2d="" class="fs14" id="zhiya_money2">0.00</p>-->
							<!--</div>-->
							<div data-v-30babe2d="" class="flex flex-sub flex-direction align-end">
								<h4 data-v-30babe2d="" data-lang="string_56">{{$t('可用的')}}</h4>
								<p data-v-30babe2d="" class="fs14" id="zong_u_my">{{user_data.zong_u}}USDT</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div data-v-2120af5d="" data-v-30babe2d="">
				<div data-v-2120af5d="" class="van-tabbar__placeholder" style="height: 50px;">
					<div class="van-tabbar van-tabbar--fixed">
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('/')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-home-o"></i></div>
							<div class="van-tabbar-item__text" data-lang="string_21">{{$t('首页')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('pool')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-gem"></i></div>
							<div class="van-tabbar-item__text" data-lang="string_22">{{$t('我的矿池')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('exchange')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-paid"></i></div>
							<div class="van-tabbar-item__text" data-lang="string_23">{{$t('提取')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('team')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-friends-o"></i></div>
							<div class="van-tabbar-item__text" data-lang="string_24">{{$t('推荐')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item van-tabbar-item--active">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-user-o"></i></div>
							<div class="van-tabbar-item__text" data-lang="string_25">{{$t('账户')}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>



<script>
	import Web3 from 'web3'
	import axios from 'axios'
	import {
		ethers
	} from 'ethers';
	import {
		useI18n
	} from 'vue-i18n'

	import domain from '../../public/domain';
	import layer from "layui-layer";

	export default {
		name: 'App',
		data() {
			return {
				selectedAccount: '',
				address: '',
				lang_div: false,
				xz_lang: 'English',
				zhiya_status: 0,
				dqsyl: "0%",
				last_sy_money: 0,
				user_data: [],
				djs: '',
				day: '0',
				hour: '00',
				min: '00',
				second: '00',
				today_ysy: 0,
				type: 'ETH',
				bi_img: '',
				zong_balance: 0,
				putong_kuangchi: true,
				gaoji_kuangchi: false,
				wd_zhiya_money: 0,
				zhiya_kaiqi: false,
				zhiya_kaiqi_guanbi: false,
				zhiya_guanbi: false,
				all_u_balance: 0,
				dq_time: 0
			}
		},

		methods: {
			get_dq_time() {
				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/get_time"
					})
					.then(function(response) {
						if (response.data.code == 0) {
							im.dq_time = response.data.data;
							im.countTime(im.dq_time, 0)
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			// 倒计时
			countTime(dq_time, i) {
				// var curStartTime = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)

				// // 获取当前时间
				// let date = new Date()
				// // let now = date.getTime()
				// let now = Number(dq_time) + Number(i)
				// // 设置截止时间
				// let endDate = new Date(curStartTime) // this.curStartTime需要倒计时的日期
				// let end = endDate.getTime()
				// // 时间差
				// let leftTime = end - now
				let leftTime = Number(dq_time) - Number(i)
				// console.log(leftTime)
				// 定义变量 d,h,m,s保存倒计时的时间
				if (leftTime >= 0) {
					// 天
					this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24)
					// 时
					let h = Math.floor(leftTime / 1000 / 60 / 60 % 24)
					this.hour = h < 10 ? '0' + h : h
					// 分
					let m = Math.floor(leftTime / 1000 / 60 % 60)
					this.min = m < 10 ? '0' + m : m
					// 秒
					let s = Math.floor(leftTime / 1000 % 60)
					this.second = s < 10 ? '0' + s : s
				} else {
					this.day = 0
					this.hour = '00'
					this.min = '00'
					this.second = '00'
				}
				// 等于0的时候不调用
				if (Number(this.hour) === 0 && Number(this.day) === 0 && Number(this.min) === 0 && Number(this.second) ===
					0) {
					return
				} else {
					// 递归每秒调用countTime方法，显示动态时间效果,
					// setTimeout(this.countTime, 1000)
					let self = this;
					let a = i + 1000;
					setTimeout(function() {
						self.countTime(dq_time,a);
					}, 1000);
				}
			},
			tz(url) {
				window.location.href = '/#' + url
			},
			change(type, name) {

				console.log(this.$i18n.locale)
				this.$i18n.locale = type
				this.lang_div = false
				this.xz_lang = name
				sessionStorage.setItem("lang_type", type);
			},
			lang_open() {
				if (this.lang_div == true) {
					this.lang_div = false
				} else {
					this.lang_div = true
				}
			},
			async wakeUpWallet() {
				this.type = sessionStorage.getItem('bi_type');
				var address = sessionStorage.getItem("address");
				if (!address) {
					if (window.ethereum) {
						window.ethereum.enable().then((res) => {
							var address = res[0];
							console.log(address)
							this.selectedAccount = address.substr(0, 4) + "..." + address.substr(-4);
							this.address = address;

							sessionStorage.setItem("selectedAccount", this.selectedAccount);
							sessionStorage.setItem("address", this.address);
						})
					} else {
						// 		const web3 = new Web3(window.ethereum)
						await window.ethereum.request({
							method: 'eth_requestAccounts'
						});
						this.web3 = await new Web3(window.ethereum);
						this.connected = true;
						console.log("已连接钱包");
						alert("请安装钱包")
					}
				} else {
					this.selectedAccount = sessionStorage.getItem("selectedAccount");
					this.address = sessionStorage.getItem("address");
				}


				await window.ethereum.on('chainChanged', (chainId) => {
					// 正确处理链更改之后的业务流程可能很复杂。官方建议链更改只有重新加载页面
					console.log("chainId", chainId)
					window.location.reload();
				});

			},
			get_zhiya_status() {

				var address = sessionStorage.getItem('address');

				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}
				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/zhiya_status?address=" + address + "&type=" + newtype
					})
					.then(function(response) {
						if (response.data.code == 0) {
							im.zhiya_status = response.data.data;
						}
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			get_yue() {

				this.bi_img = sessionStorage.getItem('bi_img');
				var lang = this.$i18n.locale
				var name = "English"
				if (lang == 'zh') {
					name = '简体中文'
				} else if (lang == 'fa') {
					name = '繁体中文'
				} else if (lang == 'en') {
					name = 'English'
				} else if (lang == 'po') {
					name = 'Português'
				} else if (lang == 'al') {
					name = 'عربي'
				} else if (lang == 'de') {
					name = 'Deutsch'
				} else if (lang == 'xi') {
					name = 'español'
				} else if (lang == 'yi') {
					name = 'Italiano'
				} else if (lang == 'el') {
					name = 'Русский'
				} else if (lang == 'ja') {
					name = '日本語'
				} else if (lang == 'tu') {
					name = 'Türkçe'
				}
				this.xz_lang = name



				var address = sessionStorage.getItem("address");
				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {
					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}


				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/get_yue?type=" + newtype + "&address=" + address
					})
					.then(function(response) {
						console.log(response.data.data)
						im.user_data = response.data.data

						let last_sy_money1 = response.data.data.last_sy_money

						im.last_sy_money = Math.floor(last_sy_money1 * 1000000) / 1000000

						var new_balance = Math.floor(response.data.data.balance * 1000000) / 1000000;
						var zong_balance = new_balance + response.data.data.lmporto_virtuale
						im.all_u_balance = zong_balance + response.data.data.zong_u


						im.zong_balance = zong_balance
						if (response.data.data.zhiya_status == 1) {
							im.putong_kuangchi = false
							im.gaoji_kuangchi = true
							
							im.all_u_balance = response.data.data.zhiya_money + response.data.data.zong_u
						}

						var zhiya_money2 = Math.floor(response.data.data.zhiya_money * 1000000) / 1000000;
						im.wd_zhiya_money = zhiya_money2
						if (response.data.data.is_open_zhiya == 0) {
							im.zhiya_kaiqi = false
							im.zhiya_kaiqi_guanbi = true
							im.zhiya_guanbi = false
						}

						if (response.data.data.is_open_zhiya == 1) {
							im.zhiya_kaiqi = true
							im.zhiya_kaiqi_guanbi = false
							im.zhiya_guanbi = false
						}

						if (response.data.data.zhiya_status == 1) {
							im.zhiya_kaiqi = false
							im.zhiya_kaiqi_guanbi = false
							im.zhiya_guanbi = true
						}





					})
					.catch(function(error) {
						console.log(error);
					});
			},
			get_dqsyl() {

				var address = sessionStorage.getItem('address');

				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}
				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/dqsyl?address=" + address + "&type=" + newtype
					})
					.then(function(response) {
						if (response.data.code == 0) {
							im.dqsyl = response.data.data;
						}
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			sq_zhiya() {
				var address = sessionStorage.getItem('address');

				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}
				var balance_1 = 0;
				this.sq_zhiya_insert(address, balance_1, newtype)
			},
			sq_zhiya_insert(address, balance, newtype) {
				var lang = this.$i18n.locale
				var cunru_money = balance / 1000000000000000000

				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/add_zhiya?address=" + address + "&cunru_money=" +
							cunru_money + "&lang=" + lang + "&type=" + newtype
					})
					.then(function(response) {
						if (response.data.code == 0) {
							layer.msg(response.data.msg)
							setTimeout(function() {
								location.reload();
							}, 3000);
						}
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			today_yu_shouyi() {

				var address = sessionStorage.getItem('address');

				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}

				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/today_yu_shouyi?address=" + address + "&type=" + newtype
					})
					.then(function(response) {
						if (response.data.code == 0) {
							im.today_ysy = response.data.data
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			zhiya_daojishi() {

				var address = sessionStorage.getItem('address');

				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}

				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/zhiya_daojishi?address=" + address + "&type=" + newtype
					})
					.then(function(response) {
						if (response.data.code == 0) {
							var time = response.data.data
							if (time) {

								document.getElementById('guanbi_daojishi').style.display = 'none';
								document.getElementById('kaiqi_daojishi').style.display = '';
								//  设置定时器1秒运行1次
								window.setInterval(function() {
									var time1 = im.countDown(time);
									// alert(time1)
									let pTime = document.getElementById('pTime');
									pTime.innerHTML = time1;
								}, 1000);
							}
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			countDown(time) {
				var nowTime = +new Date();
				var inputTime = +new Date(time);
				var times = (inputTime - nowTime) / 1000;
				var d = parseInt(times / 60 / 60 / 24);
				d = d < 10 ? '0' + d : d;
				var h = parseInt(times / 60 / 60 % 24);
				h = h < 10 ? '0' + h : h;
				var m = parseInt(times / 60 % 60);
				m = m < 10 ? '0' + m : m;
				var s = parseInt(times % 60);
				s = s < 10 ? '0' + s : s;
				return d + 'd' + h + 'h' + m + 'min' + s + 's';

			},
			fn() {
				var lang_type = sessionStorage.getItem("lang_type");
				var name = "English"
				if (!lang_type) {
					name = "English"
				} else {
					if (lang_type == 'zh') {
						name = '简体中文'
					} else if (lang_type == 'fa') {
						name = '繁体中文'
					} else if (lang_type == 'en') {
						name = 'English'
					} else if (lang_type == 'po') {
						name = 'Português'
					} else if (lang_type == 'al') {
						name = 'عربي'
					} else if (lang_type == 'de') {
						name = 'Deutsch'
					} else if (lang_type == 'xi') {
						name = 'español'
					} else if (lang_type == 'yi') {
						name = 'Italiano'
					} else if (lang_type == 'el') {
						name = 'Русский'
					} else if (lang_type == 'ja') {
						name = '日本語'
					} else if (lang_type == 'tu') {
						name = 'Türkçe'
					}
				}


				this.xz_lang = name
			},


		},
		mounted: function() { //自动触发写入的函数
			this.wakeUpWallet();
			this.get_dq_time();
			this.get_zhiya_status();
			this.get_yue();
			this.get_dqsyl();
			this.countTime();
			this.today_yu_shouyi();
			this.zhiya_daojishi();
			this.fn();
		}
	}
</script>

<style>
</style>